var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31.552,
  height: 29.191
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".order_svg__cls-4{stroke:#fff;stroke-miterlimit:10;fill:none;stroke-linecap:round;stroke-width:1.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "order_svg__\\uC7AC\\uB8CC\\uC8FC\\uBB38\\uD604\\uD669-_\\uD30C\\uB791\\uC0C9",
  transform: "translate(.5 .85)"
}, /*#__PURE__*/React.createElement("path", {
  id: "order_svg__\\uC0AC\\uAC01\\uD615_1489",
  fill: "#1291d9",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.7,
  d: "M2.859 0a2.86 2.86 0 0 1 2.858 2.859v9.718a.257.257 0 0 1-.257.257H0V2.859A2.86 2.86 0 0 1 2.859 0z",
  transform: "translate(24.485)"
}), /*#__PURE__*/React.createElement("path", {
  id: "order_svg__\\uD328\\uC2A4_297",
  fill: "#1291d9",
  d: "M273.055 499.706h-17.667a2.54 2.54 0 0 0-2.516 2.567v21.947a2.54 2.54 0 0 0 2.516 2.568h15.153a2.54 2.54 0 0 0 2.515-2.568v-21.656a2.84 2.84 0 0 1 2.8-2.858z",
  transform: "translate(-248.512 -499.706)"
}), /*#__PURE__*/React.createElement("path", {
  id: "order_svg__\\uD328\\uC2A4_298",
  fill: "#1291d9",
  stroke: "#fff",
  strokeMiterlimit: 10,
  d: "M266.47 526.572v-3.059a.255.255 0 0 0-.252-.257h-17.907a.254.254 0 0 0-.252.257v3.059a3.16 3.16 0 0 0 3.126 3.191H269.6a3.16 3.16 0 0 1-3.13-3.191z",
  transform: "translate(-248.059 -501.923)"
}), /*#__PURE__*/React.createElement("path", {
  id: "order_svg__\\uC120_37",
  d: "M0 0h6.202",
  className: "order_svg__cls-4",
  transform: "translate(8.319 5.799)"
}), /*#__PURE__*/React.createElement("path", {
  id: "order_svg__\\uC120_38",
  d: "M0 0h12.164",
  className: "order_svg__cls-4",
  transform: "translate(8.319 10.077)"
}), /*#__PURE__*/React.createElement("path", {
  id: "order_svg__\\uC120_39",
  d: "M0 0h12.164",
  className: "order_svg__cls-4",
  transform: "translate(8.319 14.437)"
}))));
export { SvgOrder as ReactComponent };
export default __webpack_public_path__ + "static/media/order.a1e96186.svg";